import React, { FC } from 'react'
import { IconComponent, UISizes, UITypes } from 'LibNeo'
import './IconGroup.scss'
import { IconAbsolute } from './styled'

interface IconGroupProps {
	statusIcon?: { name: string; type?: UITypes }
	commonIconName?: string
}

export const IconGroupComponent: FC<IconGroupProps> = ({
	statusIcon = { name: 'check-checked' },
	commonIconName = 'star-outline',
}) => {
	return (
		<div className="ppneo-icon-group">
			<IconAbsolute name={statusIcon.name} type={statusIcon?.type ?? UITypes.PRIMARY} />
			<IconComponent name={commonIconName} size={UISizes.SMALL} type={UITypes.MAIN} />
		</div>
	)
}
